export default Object.freeze({
  SINGER_TAPS_ENABLED: 'SINGER_TAPS_ENABLED',
  NATIVE_TAPS_ENABLED: 'NATIVE_TAPS_ENABLED',
  GENERIC_TAPS_ENABLED: 'GENERIC_TAPS_ENABLED',
  RESYNC_TOOL: 'RESYNC_TOOL',
  DATA_OBSERVABILITY_ENABLED: 'DATA_OBSERVABILITY_ENABLED',
  SANDBOX_TESTING: 'SANDBOX_TESTING',
  ETL_SCRIPT: 'ETL_SCRIPT',
  S3_FILE_FORMAT_PICKER: 'S3_FILE_FORMAT_PICKER',
  NEW_OBSERVABILITY_METRICS: 'NEW_OBSERVABILITY_METRICS',
  SNOWFLAKE_KEY_PAIR_AUTH: 'SNOWFLAKE_KEY_PAIR_AUTH',
  HISTORY_MODE_SCD2: 'HISTORY_MODE_SCD2',
  MYSQL_REPLICATION_MODE: 'MYSQL_REPLICATION_MODE',
  CUSTOM_TABLE_LIST_FETCH: 'CUSTOM_TABLE_LIST_FETCH',
  TEST_SINK_ENABLED: 'TEST_SINK_ENABLED',
  FORCE_STOP_PIPELINE: 'FORCE_STOP_PIPELINE',
  PUBLIC_API: 'PUBLIC_API',
  PIPELINE_DEFINITION_IMPORT_EXPORT: 'PIPELINE_DEFINITION_IMPORT_EXPORT',
  AUTO_SYNC_NEW_COLUMNS: 'AUTO_SYNC_NEW_COLUMNS',
  SKIP_VALIDATION: 'SKIP_VALIDATION',
  SALESFORCE_LOOKBACK_WINDOW: 'SALESFORCE_LOOKBACK_WINDOW',
});
